/**
 * Simple progress bar for rebus station completion.
 *
 * @param {Object} props
 * @param {number} props.completed - Number of completed items
 * @param {number} props.total - Total number of items
 * @param {string} [props.label] - Custom label text (defaults to "X av Y stasjonar")
 */
export default function RebusProgressBar({ completed, total, label }) {
  const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-sm font-semibold text-teal-800">
          {label || `${completed} av ${total} stasjonar`}
        </span>
        <span className="text-sm font-bold text-teal-600">{percentage}%</span>
      </div>
      <div className="w-full h-3 bg-teal-100 rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-teal-500 to-emerald-400 rounded-full transition-all duration-500 ease-out"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}
